import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap } from 'rxjs';
import { AuthenticationService } from '../authentication.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let token = localStorage.getItem('token');
  let auth = inject(AuthenticationService);

  let authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq).pipe(
    catchError((err) => {
      if (err.status == 401) {
        return auth.refreshToken().pipe(
          switchMap((data) => {
            authReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${data.token}`,
              },
            });
            return next(authReq);
          })
        );
      } else {
        throw err;
      }
    })
  );
};
